var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5C5 7.5 7.5 5 10.5 5S16 7.5 16 10.5 13.5 16 10.5 16 5 13.5 5 10.5zm16 8.9L16.6 15c.9-1.3 1.5-2.8 1.5-4.5 0-4.2-3.4-7.6-7.6-7.6C6.4 3 3 6.4 3 10.6s3.4 7.6 7.6 7.6c1.7 0 3.2-.6 4.5-1.5l4.4 4.4 1.5-1.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchWhite);
export default __webpack_public_path__ + "static/media/ic_search_white.934a4504d67c745340844869380ec98a.svg";
export { ForwardRef as ReactComponent };